module.exports = __webpack_public_path__ + "img/logo.b2aea4e7.svg";